
import React, { ReactNode, useState } from 'react';
import { NavLink } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


import { FaLinkedin, FaMailBulk, FaFacebookSquare, FaPhoneSquare } from "react-icons/fa";
import AnimationDotGrid from './AnimationDotGrid';

// Define the props for PublicBankLayout
interface PublicBankLayoutProps {
  children: ReactNode; // Specifies that children can be any valid React element
}

const PublicBankLayout: React.FC<PublicBankLayoutProps> = ({ children }) => {


  const currentYear = new Date().getFullYear();


  const linkStyle: React.CSSProperties = {
    color: 'white', // Gold color
    textDecoration: 'none',
    fontWeight: 'bold',
    transition: 'color 0.3s ease, transform 0.3s ease', // Smooth transition for color and transform
  };

  const linkHoverStyle: React.CSSProperties = {
    color: '#0000007a', // Tomato color for hover

  };

  const [hovered, setHovered] = useState(false);



  function formatDate() {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const currentDate = new Date();

    const monthName = months[currentDate.getMonth()];
    const day = currentDate.getDate();
    const year = currentDate.getFullYear();

    return `${monthName} ${day}, ${year}`;
  }
  const formattedDate = formatDate();



  return (
    <>

      {/* Header Start  */}
      <div className="CommonBG p-1"></div>

      <div className="TopBarBG">


        <Container>
          <Row>





            <Col sm={8} className='text-center text-sm-start text-white'>

              <NavLink className="TopBarNavLink" to={`/MyBank`}>
                Home
              </NavLink>

              <NavLink className="TopBarNavLink" to={`/AccountPrint`}>
                Account Print
              </NavLink>

              <NavLink className="TopBarNavLink" to={`/RemittanceCalculation`}>
                Remittance Calculation
              </NavLink>

              <NavLink className="TopBarNavLink" to={`/DPSCalculation`}>
                DPS Calculation
              </NavLink>

              <NavLink className="TopBarNavLink" to={`/FDRCalculation`}>
                FDR Calculation
              </NavLink>

              <NavLink className="TopBarNavLink" to={`/LoanCalculation`}>
                Loan Calculation
              </NavLink>


              <NavLink className="TopBarNavLink" to={`/ContactUs`}>
                Contact
              </NavLink>


            </Col>








            <Col sm={4} className='text-center   text-sm-end'>


              <div className="text-white justify-content-center">


                <a style={{ textDecoration: "none", color: "white", paddingRight: "5px" }} href="https://www.facebook.com/RaselHossainAdib" target="_blank" rel="noopener noreferrer"><span className='CommonHover'> <FaFacebookSquare /> </span></a>
                <a style={{ textDecoration: "none", color: "white", paddingRight: "5px" }} href="https://www.linkedin.com/in/raselhossainadib/" target="_blank" rel="noopener noreferrer"><span className='CommonHover'> <FaLinkedin /> </span></a>
                <a style={{ textDecoration: "none", color: "white", paddingRight: "5px" }} href="mailto:adibrasel.com@gmail.com" target="_blank" rel="noopener noreferrer"><span className='CommonHover'> <FaMailBulk />  </span></a>
                <a style={{ textDecoration: "none", color: "white", paddingRight: "5px" }} href="tel:+8801934544352" target="_blank" rel="noopener noreferrer"><span className='CommonHover'> <FaPhoneSquare /> </span></a>
                <a style={{ textDecoration: "none", color: "white", paddingRight: "5px" }} href="tel:+8801626757897" target="_blank" rel="noopener noreferrer"><span className='CommonHover'> <FaPhoneSquare /> </span></a>

                <span className='text-light me-4'>{formattedDate}</span>

              </div>

            </Col>




          </Row>
        </Container>

      </div>
      {/* Header End */}


      <div className="position-relative" style={{ minHeight: 'auto', height: 'auto', width: '100%' }}>
        {/* Background DotGrid */}
        <div className="position-absolute top-0 start-0 w-100 h-100 overflow-hidden" style={{ zIndex: 0, minHeight: 'auto', height: 'auto', width: '100%' }}>
          {/* <DotGrid /> */}
          <AnimationDotGrid />
        </div>

        {/* All content */}
        <div className="position-relative container" style={{ zIndex: 1, backgroundColor: "#909293d6" }}>
          {children} {/* This renders the children elements passed to the component */}
        </div>
      </div>



      <footer style={footerStyle}>
        <p>&copy; {currentYear} <a
          href="https://adibrasel.github.io/My_Portfolio/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            ...linkStyle,
            color: hovered ? linkHoverStyle.color : linkStyle.color, // Apply color change on hover
            transform: hovered ? linkHoverStyle.transform : 'scale(1)' // Apply transform on hover
          }}
          onMouseEnter={() => setHovered(true)} // On mouse enter, set hovered to true
          onMouseLeave={() => setHovered(false)} // On mouse leave, set hovered to false
        >
          Rasel Hossain Adib.
        </a> All rights reserved.</p>
      </footer>


    </>

  );
};


const footerStyle: React.CSSProperties = {
  backgroundColor: 'rgb(71 79 122)',
  padding: '10px',
  textAlign: 'center',
  color: "white",
};
export default PublicBankLayout;
